import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"left","margin-bottom":"10px"} }
const _hoisted_2 = { style: {"margin-bottom":"20px","text-align":"right"} }
const _hoisted_3 = { style: {"display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_4 = { class: "el-dropdown-link vo-ft-pry" }

import { reactive, ref, unref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { GbTables } from '@/components/GbTables';
import { RulesDialog, DeptPostRelList } from './components/Index';
import { useGbTable } from '../../../hooks/useGbTable';
import { useDictionary } from '@/store/dictionary.store';
// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';
import { GetCatRuleListApi, DelCatRuleListApi } from '@/apis/basics/rules/apis';
import { TableColumn } from '../../../components/GbTables/GbTablesTypes';
import { CatRulesSearch } from '@/apis/basics/rules/dtos';
import { CategoryTreeList } from '@/components/lists/Index';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useLocales();

const { query } = useRoute();
const { getName } = useDictionary();

const search = reactive<CatRulesSearch>({
	page_size: 10,
	current: 1,
	category_id: '',
});

/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<any>({
	getListApi: GetCatRuleListApi,
	delListApi: DelCatRuleListApi,
	response: { data: 'data', total: 'total' },
});

const { setSearchParams } = methods;

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
	{ field: 'category_name', label: t('draft.contractCategory', '合同分类'), columnWidth: '200' },
	{ field: 'rule_name', label: t('rules.table.ruleName', '规则名称'), columnWidth: '240' },
	{ field: 'node_id', label: t('rules.table.approvalNode', '审批节点'), columnWidth: '110', align: 'center' },
	{ field: 'amt_range', label: t('rules.table.amountRange', '金额区间'), columnWidth: '150', align: 'right' },
	{ field: 'mainstay_name', label: t('rules.table.applicableEntity', '适用主体') },
	{ field: 'is_enabled', label: t('rules.table.enabled', '启用'), columnWidth: '80', align: 'center' },
	{ field: 'created_time', label: t('rules.table.createdDate', '创建日期'), columnWidth: '120', fixed: 'right' },
	{ field: 'action', width: '120px', label: t('contractList.table.action', '操作'), fixed: 'right', align: 'center' },
]);

const writerRef = ref<InstanceType<typeof RulesDialog>>();
const deptRelRef = ref<InstanceType<typeof DeptPostRelList>>();

const actions = {
	/* 打开编辑器 */
	creation: () => {
		unref(writerRef)?.create();
	},

	/* 修改配置 */
	modify: (row: any) => {
		unref(writerRef)?.modify(row.id);
	},

	/* 刷新数据 */
	refresh: () => {
		search.current = 1;
		search.page_size = 10;
		search.category_id = '';
		search.rule_name = '';

		setSearchParams(search);
	},

	/* 删除配置 */
	delete: async (row: any) => {
		await methods.deleteRows({ id: row.id, revision: row.revision });
	},

	/* 部门/职位关联 */
	deptPostRel: (row: any) => {
		unref(deptRelRef)?.showDialog(row.id);
	},

	nodeChange: (node: any) => {
		search.category_id = node;
		setSearchParams(search);
	},
};

onMounted(async () => {
	setSearchParams(search);
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, { gutter: 10 }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_unref(CategoryTreeList), {
              onNodeChange: actions.nodeChange
            }, null, 8, ["onNodeChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 20 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_el_card, {
                shadow: "never",
                "body-style": { paddingBottom: '0' }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form, {
                    size: "small",
                    model: _unref(search),
                    inline: true,
                    class: "demo-form-inline"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, {
                        "label-width": '80px',
                        label: _unref(t)('rules.table.ruleName', '规则名称')
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: _unref(search).rule_name,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(search).rule_name) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "info",
                            onClick: actions.refresh
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('buttons.cancel', '重置')), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_el_button, {
                            type: "primary",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setSearchParams)(_unref(search))))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('buttons.search', '查询')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_card, { shadow: "never" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_el_button, {
                    size: "small",
                    type: "primary",
                    onClick: actions.creation
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('rules.buttons.addRule', '新增规则')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _createVNode(_unref(GbTables), {
                  pageSize: _unref(tableObject).pageSize,
                  "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
                  currentPage: _unref(tableObject).currentPage,
                  "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
                  columns: _unref(tabColumns),
                  data: _unref(tableObject).tableList,
                  loading: _unref(tableObject).loading,
                  pagination: { total: _unref(tableObject).total },
                  onRegister: _unref(register)
                }, {
                  node_id: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(getName)('OA_199', row.node_id)), 1)
                  ]),
                  created_time: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format('YYYY-MM-DD HH:mm')), 1)
                  ]),
                  specify_names: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.specify_names || _unref(t)('rules.common.notSpecified', '未指定')), 1)
                  ]),
                  amt_range: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(row.amount_min.toLocaleString('zh')) + " ~ " + _toDisplayString(row.amount_max.toLocaleString('zh')), 1)
                  ]),
                  is_enabled: _withCtx(({ row }) => [
                    _createVNode(_component_el_tag, {
                      size: "small",
                      type: row.is_enabled == 'Y' ? 'success' : 'danger'
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(row.is_enabled == 'Y' ? _unref(t)('status.enabled', '启用') : _unref(t)('status.diabled', '停用')), 1)
                      ]),
                      _: 2
                    }, 1032, ["type"])
                  ]),
                  action: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_el_button, {
                        type: "success",
                        link: "",
                        onClick: ($event: any) => (actions.modify(row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)('buttons.modify', '修改')), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]),
                      _createVNode(_component_el_dropdown, {
                        style: {"padding":"2px","margin-left":"12px"},
                        trigger: "click"
                      }, {
                        dropdown: _withCtx(() => [
                          _createVNode(_component_el_dropdown_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_dropdown_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "info",
                                    link: "",
                                    onClick: ($event: any) => (actions.deptPostRel(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('rules.buttons.deptPost', '部门/职位')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_dropdown_item, { divided: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    type: "danger",
                                    link: "",
                                    onClick: ($event: any) => (actions.delete(row))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref(t)('buttons.delete', '删除')), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('rules.buttons.more', '更多')), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 1
                }, 8, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_unref(RulesDialog), {
      ref_key: "writerRef",
      ref: writerRef,
      onSaveData: actions.refresh
    }, null, 8, ["onSaveData"]),
    _createVNode(_unref(DeptPostRelList), {
      ref_key: "deptRelRef",
      ref: deptRelRef
    }, null, 512)
  ], 64))
}
}

})